import React from "react";
import { Sparkles, ShieldCheck, FileCheck2, Scale, CheckCircle2, AlertCircle } from "lucide-react";

/**
 * Trust / transparency badges used across article pages + cards.
 * Variants: ai | human | source | legal | updated | correction | risk
 */
const VARIANTS = {
  ai:         { label: "AI-assisted",         tone: "blue",  Icon: Sparkles },
  human:      { label: "Human reviewed",      tone: "green", Icon: ShieldCheck },
  source:     { label: "Source-backed",       tone: "gold",  Icon: FileCheck2 },
  legal:      { label: "Legal information only", tone: "",   Icon: Scale },
  correction: { label: "Correction policy",   tone: "",      Icon: CheckCircle2 },
  updated:    { label: "Updated",             tone: "gold",  Icon: CheckCircle2 },
  risk_low:   { label: "Low risk",            tone: "green", Icon: ShieldCheck },
  risk_med:   { label: "Medium risk",         tone: "amber", Icon: AlertCircle },
  risk_high:  { label: "High risk",           tone: "red",   Icon: AlertCircle },
};

export default function Badge({ variant, label, className = "", testId }) {
  const v = VARIANTS[variant] || { label: label || variant, tone: "", Icon: null };
  const toneClass = v.tone ? `io-badge-${v.tone}` : "";
  const Icon = v.Icon;
  return (
    <span className={`io-badge ${toneClass} ${className}`} data-testid={testId}>
      {Icon && <Icon size={11} />}
      <span>{label || v.label}</span>
    </span>
  );
}
